import firebaseApp from "../firebase/credenciales";
import { getFirestore, deleteDoc, collection, doc } from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default async function eliminarProducto(producto, usuario,productofolio) {
  const coleccionRef = collection(db, "/Productos".replace(/ /g, ""));
  const docuRef = doc(coleccionRef, producto.nombre);
  const eliminado = await deleteDoc(docuRef);

  //escribirLog("Eliminación", producto, usuario);

  return eliminado;
}
